export default "__VITE_ASSET__BrkZHDJ___"